import axios from 'axios'
import {getAdminToken} from '../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL

const adminApi = axios.create({withCredentials: true})
adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export type AlertLevel = 'red' | 'orange' | 'gray' | 'ok'
export type AlertCode = 'not_posting' | 'unconfirmed' | 'low_ratio' | 'declines' | 'notif_stale' | 'ok'

export interface AccountRow {
  account_id: string
  name: string
  phone: string
  profiles: number
  scheduled: number
  due: number
  posted: number
  posted_checked: number
  live: number
  live_prev_per_day: number
  approved: number
  crosspost: number
  declined: number
  groups_live: number
  last_live_at: string | null
  last_notif_sync: string | null
  ratio: number | null
  alert: AlertLevel
  alert_code: AlertCode
}

export interface GroupRow {
  group_fb_id: string
  name: string
  live: number
  declined: number
  accounts: number
  profiles: number
  last_at: string
}

export interface SummaryResponse {
  success: boolean
  window_days: number
  window_start: string
  totals: {accounts: number; posted: number; live: number; declined: number; red: number; orange: number; gray: number; ok: number}
  accounts: AccountRow[]
  groups: GroupRow[]
  generated_at: string
}

export interface AccountDetailResponse {
  success: boolean
  window_days: number
  account: {_id: string; name: string; phone: string; email: string}
  daily: {date: string; scheduled: number; posted: number; live: number; declined: number}[]
  profiles: {
    _id: string
    name: string
    is_sub: boolean
    last_notif_sync: string | null
    scheduled: number
    due: number
    posted: number
    live: number
    declined: number
    last_live_at: string | null
  }[]
  groups: {group_fb_id: string; name: string; scheduled: number; posted: number; live: number; declined: number; last_live_at: string | null}[]
  recent: {_id: string; kind: 'crosspost' | 'approved' | 'scheduled' | 'declined'; group_fb_id: string; group_name: string; url: string; event_at: string; profile: string}[]
}

export function getPostConfirmations(days: number): Promise<{data: SummaryResponse}> {
  return adminApi.get(`${API_URL}/admin/post-confirmations`, {params: {days}})
}

export function getAccountConfirmations(id: string, days: number): Promise<{data: AccountDetailResponse}> {
  return adminApi.get(`${API_URL}/admin/post-confirmations/account/${id}`, {params: {days}})
}
